import React from 'react'
import PageContainer from '../components/PageContainer'
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';

function DownloadTutorial() {
    const { t } = useTranslation();
    return (
        <PageContainer items="center">
            <Helmet>
                <title>Scarica l'app - TicinoWild</title>
                <meta name="description" content="Aggiungi TicinoWild alla schermata Home del tuo dispositivo. Guida video per Safari su iOS e Chrome su Android." />
                <link rel="canonical" href="https://ticinowild.ch/download-app-tutorial" />
                <meta property="og:title" content="Scarica l'app - TicinoWild" />
                <meta property="og:description" content="Aggiungi TicinoWild alla schermata Home del tuo dispositivo. Guida video per Safari su iOS e Chrome su Android." />
                <meta property="og:url" content="https://ticinowild.ch/download-app-tutorial" />
                <meta name="twitter:title" content="Scarica l'app - TicinoWild" />
                <meta name="twitter:description" content="Aggiungi TicinoWild alla schermata Home del tuo dispositivo. Guida video per Safari su iOS e Chrome su Android." />
            </Helmet>
            <h3 className="text-[#225424] text-center">{t("DownloadApp.add")} <span className="font-signature text-2xl text-[#b05704]">TicinoWild</span> {t("DownloadApp.toHome")}</h3>
            <div className='mt-8 flex flex-col md:flex-row items-center gap-8'>
                <video width="360" height="640" controls className='rounded-xl' poster='/videos/posters/safari-poster.jpg'>
                    <source src="/videos/safari-download-app.mp4" type="video/mp4" />
                    {t("DownloadApp.browserNotSupported")}
                </video>
                <video width="360" height="640" controls className='rounded-xl' poster='/videos/posters/chrome-poster.jpg'>
                    <source src="/videos/chrome-download-app.mp4" type="video/mp4" />
                    {t("DownloadApp.browserNotSupported")}
                </video>
            </div>

        </PageContainer>
    )
}

export default DownloadTutorial